export default class Model {

    /**
     * Builds a model from a object literal.
     * @param data
     */
    constructor(data) {
        for(let property in data) {
            this[property] = data[property];
        }
    }

    static makeArray(data) {
        let array = [];
        for(let i in data) {
            array.push(new this(data[i]));
        }

        return array;
    }

}